import { useVoiceDemo } from '../../providers/VoiceDemoContext';

import { VoiceCard } from './VoiceCard';
import { ChevronDown } from '../icons/ChevronDown';
import { useEffect, useRef, useState } from 'react';
import { BoringAvatar } from '../BoringAvatar';

export function VoiceList() {
  const { currentLanguage, handleUpdateVoice, currentVoice, error } =
    useVoiceDemo();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        key={currentVoice.name}
        className={`flex w-full min-w-[160px] cursor-pointer items-center justify-between gap-1 rounded-2xl border-[1px] px-[16px] py-[8px] font-medium leading-normal hover:bg-[#F5F5FA] @sm:gap-2 ${isDropdownOpen ? 'border-[#9899A6]' : 'border-[#E9EAF0]'}`}
        onClick={toggleDropdown}>
        <div className="flex items-center gap-2">
          {currentVoice.image.length ? (
            <img
              src={currentVoice.image}
              className="min-h-8 min-w-8 rounded-full bg-[#f0f4f9]"
              alt={currentVoice.displayName}
              width={32}
              height={32}
            />
          ) : (
            <BoringAvatar />
          )}
          <div>
            {currentVoice.displayName}
            &nbsp;
            <span className="hidden @xsm:inline">
              {'(' + currentVoice.gender.charAt(0).toUpperCase() + ')'}
            </span>
          </div>
        </div>
        <ChevronDown />
      </button>
      {isDropdownOpen && (
        <div className="dropdown-shadow absolute top-[56px] z-50 flex max-h-[400px] w-auto flex-col gap-1 overflow-y-auto rounded-2xl border-[1px] border-[#E9EAF0] bg-white p-2 no-scrollbar">
          {currentLanguage.voices.map((voice) => {
            return (
              <VoiceCard
                gender={voice.gender}
                key={voice.name}
                image={voice.image}
                languageCode={voice.languageCode}
                isPlaceholder={!!error}
                title={voice.displayName}
                onClick={() => {
                  setIsDropdownOpen(false);
                  !error && handleUpdateVoice(voice.name);
                }}
                isSelected={voice.name === currentVoice.name}
                isSizeLarge={true}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
